/* eslint-disable max-len */
import React from 'react'

export default function TextArea({
    label,
    placeholder,
    htmlFor,
    id,
    value,
    emptyField,
    handleOnChangeInput,
    maxLength,
    isLoading,
    PatientNotes,
    dataTestid,
    TransferFileHeight
}) {
    return (
        <>
            <div className='flex flex-col h-full'>
                <label htmlFor={htmlFor} className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                {/* border-[#D3454D] */}
                <div className={`border ${emptyField?'border-[#C81720]':'border-[#C5C9DA]'} ${PatientNotes?'border-transparent':'border-[#C5C9DA]'} rounded-lg pr-1 py-1.5 bg-white ${TransferFileHeight ? 'h-[calc(100vh-455px)]' : 'h-full'}`} >
                    <textarea type="text" data-testid={dataTestid} id={id} onChange={(e) => {handleOnChangeInput(id,e.target.value)}}
                        value={value}
                        maxLength={maxLength}
                        className={`pl-3.5 pr-1 py-[5px] ${PatientNotes? "text-base" : "text-sm"} font-normal  text-[#000B17] w-full  ${PatientNotes? "placeholder:text-[#A0A0A0]":"placeholder:text-[#52555D]"} outline-none resize-none h-full scrollbar_gray rounded-lg`}
                        placeholder={placeholder} style={{height:"100%"}} >
                    </textarea>
                </div>
            </div> 
        </>
    )
}
